var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTypeInviteBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_22889)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00075,
    cy: 6.00075,
    r: 5.07692,
    fill: "#0064E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11699 7.88301C4.04208 7.808 4 7.70633 4 7.60032C4 7.49431 4.04208 7.39263 4.11699 7.31763L6.63455 4.80007H4.93306C4.82697 4.80007 4.72522 4.75792 4.6502 4.6829C4.57517 4.60788 4.53303 4.50613 4.53303 4.40004C4.53303 4.29394 4.57517 4.19219 4.6502 4.11717C4.72522 4.04215 4.82697 4 4.93306 4H7.59996C7.70606 4 7.80781 4.04215 7.88283 4.11717C7.95785 4.19219 8 4.29394 8 4.40004V7.06694C8 7.17303 7.95785 7.27478 7.88283 7.3498C7.80781 7.42483 7.70606 7.46697 7.59996 7.46697C7.49387 7.46697 7.39212 7.42483 7.3171 7.3498C7.24208 7.27478 7.19993 7.17303 7.19993 7.06694V5.36545L4.68238 7.88301C4.60737 7.95792 4.50569 8 4.39968 8C4.29367 8 4.192 7.95792 4.11699 7.88301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_22889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTypeInviteBlue);
export default __webpack_public_path__ + "static/media/MemberTypeInviteBlue.a166864e41d4039362e87fb400f4ff83.svg";
export { ForwardRef as ReactComponent };